/*
 * Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Directive} from '@angular/core';

@Directive({
  selector: '[gmPrimary]',
  standalone: true,
  host: {
    class: 'gm-btn-primary'
  }
})
export class GmPrimaryButtonDirective {
}

@Directive({
  selector: '[gmSecondary]',
  standalone: true,
  host: {
    class: 'gm-btn-secondary'
  }
})
export class GmSecondaryButtonDirective {
}

@Directive({
  selector: '[gmTertiary]',
  standalone: true,
  host: {
    class: 'gm-btn-tertiary'
  }
})
export class GmTertiaryButtonDirective {
}
